import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../views/Index.vue"),
  },
  {
    path: "/entrar",
    name: "client-login",
    component: () => import("../views/client/Login.vue"),
    meta: { guest: true },
  },
  {
    path: "/cadastro",
    name: "client-register",
    component: () => import("../views/client/Register.vue"),
    meta: { guest: true },
  },
  {
    path: "/app",
    name: "learning-library",
    component: () => import("../views/client/Contents.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/app/conteudos/:id",
    name: "learning-content",
    component: () => import("../views/client/ContentDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/app/perfil",
    name: "client-profile",
    component: () => import("../views/client/Profile.vue"),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 80 };
    }
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const authenticated = Boolean(localStorage.getItem("ondjilamed_client_token"));
  if (to.meta.requiresAuth && !authenticated) {
    return { name: "client-login", query: { redirect: to.fullPath } };
  }
  if (to.meta.guest && authenticated) return { name: "client-profile" };
  return true;
});

export default router;
